<script setup lang="ts">
  const props = defineProps<{message: string|null|undefined, customClass?: string}>()
</script>

<template>
  <div role="alert" :class="customClass ? customClass : 'wad4-generic-error'" v-if="!!message">
    {{message}}
  </div>
</template>

<style lang="scss">
  .wad4-generic-error {
    @include text-size-mixin('md');
    color: $wad4-c-text-text-error;
  }
</style>
